import React, { MouseEventHandler } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import useExtension from 'flow/hooks/useExtension';
import useVideo from 'flow/hooks/useVideo';
import { ChatSessionKey, ExtensionKey } from 'flow/types/EntityKeys';
import { twMerge } from 'tailwind-merge';
import Icon from './ui-components/Icon';
import IconButton from './ui-components/IconButton';

interface Props {
    chatSessionKey: ChatSessionKey;
    extensionKey: ExtensionKey;
}

const VideoCallButton = ({ chatSessionKey, extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const { status } = useExtension(extensionKey);
    const { startVideoCall } = useVideo(extensionKey);

    const onClickVideoCall: MouseEventHandler = async (event) => {
        event.stopPropagation();

        if (status !== 'available') {
            return;
        }

        startVideoCall(chatSessionKey);
    };

    return (
        <IconButton
            className={twMerge(
                'size-10 rounded-sm bg-gray-200',
                status === 'available'
                    ? 'hover:bg-green hover:text-white'
                    : 'cursor-not-allowed',
            )}
            onClick={onClickVideoCall}
            tooltipLabel={i18next.t('Tooltip.Title.StartVideo')}
        >
            <Icon iconKey="videoCall" />
        </IconButton>
    );
};

export default VideoCallButton;
